"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chartAxisZoomSliderHandleClasses = void 0;
exports.getAxisZoomSliderHandleUtilityClass = getAxisZoomSliderHandleUtilityClass;
exports.useUtilityClasses = void 0;
var _generateUtilityClasses = _interopRequireDefault(require("@mui/utils/generateUtilityClasses"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _generateUtilityClass = _interopRequireDefault(require("@mui/utils/generateUtilityClass"));
const chartAxisZoomSliderHandleClasses = exports.chartAxisZoomSliderHandleClasses = (0, _generateUtilityClasses.default)('MuiChartAxisZoomSliderHandle', ['root', 'horizontal', 'vertical', 'start', 'end']);
function getAxisZoomSliderHandleUtilityClass(slot) {
  return (0, _generateUtilityClass.default)('MuiChartAxisZoomSliderHandle', slot);
}
const useUtilityClasses = ownerState => {
  const {
    orientation,
    placement
  } = ownerState;
  const slots = {
    root: ['root', orientation === 'horizontal' ? 'horizontal' : 'vertical', placement === 'start' ? 'start' : 'end']
  };
  return (0, _composeClasses.default)(slots, getAxisZoomSliderHandleUtilityClass);
};
exports.useUtilityClasses = useUtilityClasses;